/**
 * @file
 * Table script.
 */

(function formsScript($, Drupal) {
  'use strict';

  /*
   * Initialize datatables.net to facilitate sorting, filtering and search.
   */
  Drupal.behaviors.filterTables = {
    attach: function (context) {
      if ($('.table--searchable', context).length) {
        var table = $('.table--searchable');
        var placeholder = Drupal.t('Filter terms or numbers');
        table.DataTable({
          dom: 'Bfrtip',
          buttons: [
            {
              text: '<i class="icon--close" aria-label="Close" role="img"></i>',
              className: 'table__clear button--close u-bg--grey--light',
              action: function (e, dt, node, config) {
                dt.search('').draw();
                clearBtn.hide();
              }
            }
          ],
          paging: false,
          info: false,
          autoWidth: false,
          language: {
            search: '_INPUT_',
            searchPlaceholder: placeholder
          },
          mark: {
            element: 'strong'
          }
        });
        var clearBtn = $('.table__clear');
        var dataTable = table.DataTable();
        clearBtn
          .appendTo('.dataTables_filter')
          .hide();
        dataTable.on('search.dt', function () {
          clearBtn.show();
        });
      }
    }
  };

}(jQuery, Drupal));
